(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cultured-product-tab"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cultured-product-card')) {
    class CulturedProductCard extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cpc-track]');
        this.dots = Array.from(this.querySelectorAll('[data-cpc-dot]'));

        if (this.track) {
          this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });
          this.dots.forEach((dot, i) => dot.addEventListener('click', (e) => {
            e.preventDefault();
            this.goTo(i);
          }));
          const prev = this.querySelector('[data-cpc-prev]');
          const next = this.querySelector('[data-cpc-next]');
          if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); this.goTo(this.index() - 1); });
          if (next) next.addEventListener('click', (e) => { e.preventDefault(); this.goTo(this.index() + 1); });

          if (this.dataset.autoplay === 'true' && window.matchMedia('(hover: hover)').matches) {
            this.addEventListener('mouseenter', () => this.startAuto());
            this.addEventListener('mouseleave', () => this.stopAuto());
          }
        }

        const wish = this.querySelector('[data-cpc-wishlist]');
        if (wish) this.initWishlist(wish);

        const add = this.querySelector('[data-cpc-add]');
        if (add) add.addEventListener('click', (e) => this.quickAdd(e, add));
      }

      disconnectedCallback() { clearInterval(this.timer); }

      slides() { return this.track ? this.track.children.length : 0; }
      index() {
        if (!this.track || !this.track.clientWidth) return 0;
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      goTo(i) {
        const n = this.slides();
        if (!n) return;
        const target = (i + n) % n;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
      }

      syncDots() {
        const i = this.index();
        this.dots.forEach((d, j) => {
          d.classList.toggle('is-active', j === i);
          d.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
      }

      startAuto() {
        clearInterval(this.timer);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.goTo(this.index() + 1), 1400);
      }

      stopAuto() {
        clearInterval(this.timer);
        if (this.track) this.track.scrollTo({ left: 0, behavior: 'smooth' });
      }

      initWishlist(btn) {
        const key = 'cpt-wishlist';
        const id = btn.dataset.productId;
        const read = () => {
          try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
        };
        const paint = (on) => {
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        };
        paint(read().includes(id));

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          let list = read();
          const on = !list.includes(id);
          list = on ? list.concat(id) : list.filter((x) => x !== id);
          try { localStorage.setItem(key, JSON.stringify(list)); } catch (err) {}
          paint(on);
          document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { productId: id, added: on, list: list } }));
        });
      }

      async quickAdd(e, btn) {
        const variantId = btn.dataset.variantId;
        if (!variantId) return; /* products with options: link opens the product page */
        e.preventDefault();
        btn.classList.add('is-loading');
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });
          if (!res.ok) throw new Error('add failed');
          const data = await res.json();
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 1600);
          /* Hook these events to your theme's cart drawer / cart count */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
        } catch (err) {
          window.location.href = btn.getAttribute('href');
        } finally {
          btn.classList.remove('is-loading');
        }
      }
    }
    customElements.define('cultured-product-card', CulturedProductCard);
  }
  } catch(e) { console.error(e); }
})();

})();
